// eslint-disable-next-line import/no-extraneous-dependencies
import { defineStore } from "pinia";
// eslint-disable-next-line import/no-extraneous-dependencies
import { computed, ref } from "vue";

export const useTableStore = defineStore("table", () => {
  // -1 = descending, 0 = none, 1 = ascending
  const sortDirection = ref(0);

  // null = no column being sorted
  const sortedIndex = ref(null);

  const tableId = ref(null);

  const directionStorageKey = computed(() => `${tableId.value}-direction`);
  const indexStorageKey = computed(() => `${tableId.value}-index`);

  function setSortDirection(direction) {
    sortDirection.value = direction;
    window.sessionStorage.setItem(directionStorageKey.value, direction);
  }

  function setSortIndex(index) {
    sortedIndex.value = index;
    window.sessionStorage.setItem(indexStorageKey.value, index);
  }

  function init(passedTableId) {
    tableId.value = passedTableId;

    const storedDirection = window.sessionStorage.getItem(directionStorageKey.value);
    if (storedDirection != null) {
      setSortDirection(Number.parseInt(storedDirection));
    }

    const storedIndex = window.sessionStorage.getItem(indexStorageKey.value);
    if (storedIndex != null) {
      setSortIndex(Number.parseInt(storedIndex));
    }
  }

  function sortTable(index) {
    // if different column, reset sort
    if (index !== sortedIndex.value) {
      setSortDirection(0);
      setSortIndex(index);
    }

    // increment in range -1 to 1
    if (sortDirection.value === 1) {
      setSortDirection(-1);
    } else {
      setSortDirection(sortDirection.value + 1);
    }
  }

  return {
    sortDirection, sortedIndex, sortTable, init,
  };
});